import React from "react";
import { Avatar, IconButton, Paper, Typography, useTheme } from "@mui/material";
import { TaskTable } from "../interfaces/Task";
import dateToHuman from "../utilities/date";
import { MAIN_URL } from "../requester/requester";
import { Link } from "react-router-dom";
import AssignmentIcon from "@mui/icons-material/Assignment";

interface IProps {
	task: TaskTable;
	selectTask?(item: TaskTable): void;
	selectedTasks: number[];
}

const TaskCard = (props: IProps) => {
	const theme = useTheme();
	return props.selectedTasks.length === 0 ||
		props.selectedTasks.indexOf(props.task.id) !== -1 ? (
		<Paper
			className="flex flex-col p-2 mb-5"
			style={{
				...(props.task.deadline &&
				props.task.deadline < new Date().getTime() / 1000
					? {
							backgroundColor: theme.palette.error.light,
					  }
					: null),
				...(props.task.deadline === null
					? {
							backgroundColor: theme.palette.warning.light,
					  }
					: null),
			}}
		>
			<div className="flex justify-between">
				<Typography>{props.task.name}</Typography>
				<Link to={`/manager/${props.task.manager.id}`}>
					<Avatar
						src={`${MAIN_URL}manager/avatar/${props.task.manager.avatar}`}
					/>
				</Link>
			</div>
			<div className="flex justify-between">
				<Typography>{props.task.description}</Typography>
			</div>
			<div className="flex justify-between">
				<Typography>
					{props.task.deadline ? dateToHuman(props.task.deadline) : "Нет даты"}
				</Typography>
				<IconButton
					onClick={() => {
						if (props.selectTask) props.selectTask(props.task);
					}}
				>
					<AssignmentIcon />
				</IconButton>
			</div>
		</Paper>
	) : null;
};

export default TaskCard;
